function formatReusableBagsAtcPriceFromCents(cents) {
  if (cents == null || typeof theme === 'undefined' || !theme.Currency || !theme.settings) {
    return '';
  }
  var fmt = theme.settings.moneyFormat || '${{amount}}';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var phMatch = fmt.match(placeholderRegex);
  if (!phMatch) {
    return theme.Currency.formatMoney(cents);
  }
  var kind = phMatch[1];
  var placeholder = phMatch[0];
  var amountHtml = theme.Currency.formatMoney(cents, '{{' + kind + '}}');
  var parts = fmt.split(placeholder);
  var prefix = (parts[0] || '').trim();
  var suffix = (parts[1] || '').trim();
  var chunks = [amountHtml, suffix, prefix].filter(function (s) {
    return s.length;
  });
  return chunks.join(' ');
}

function getReusableBagsSelectedVariantCents(root) {
  var form = root.querySelector('.product-single__form--reusable-bags');
  if (!form) return null;
  var sel = form.querySelector('[data-product-select]');
  var jsonEl = form.querySelector('[data-variant-json]');
  if (!sel || !jsonEl) return null;
  var variants;
  try {
    variants = JSON.parse(jsonEl.textContent || jsonEl.innerHTML || '[]');
  } catch (_) {
    return null;
  }
  if (!Array.isArray(variants)) return null;
  var id = parseInt(sel.value, 10);
  var found = variants.find(function (v) {
    return v.id === id;
  });
  return found ? found.price : null;
}

/* VariantAvailability treats option2+ as dependent on earlier options; type-of-bag must stay enabled whenever any variant with that type is purchasable. */
function syncReusableBagsTypePickerAvailability(root) {
  var form = root.querySelector('.product-single__form--reusable-bags');
  var typeFieldset = root.querySelector('fieldset.variant-input-wrap--reusable-bags-type');
  var variantJsonEl = form && form.querySelector('[data-variant-json]');
  if (!typeFieldset || !variantJsonEl) return;

  var variants;
  try {
    variants = JSON.parse(variantJsonEl.textContent || variantJsonEl.innerHTML || '[]');
  } catch (_) {
    return;
  }
  if (!Array.isArray(variants) || variants.length === 0) return;

  var typeIdx = typeFieldset.getAttribute('data-index');
  if (!typeIdx) return;

  typeFieldset.querySelectorAll('.variant-input').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="radio"][data-variant-input]');
    var label = wrap.querySelector('label.reusable-bags-type-row');
    if (!input || !label) return;

    var typeVal = input.value;
    var hasAvailable = variants.some(function (v) {
      return v[typeIdx] === typeVal && v.available;
    });

    if (hasAvailable) {
      input.classList.remove('disabled');
      label.classList.remove('disabled');
    } else {
      input.classList.add('disabled');
      label.classList.add('disabled');
    }
  });
}

function initReusableBagsSizeByType(root) {
  const form = root.querySelector('.product-single__form--reusable-bags');
  if (!form) return;

  const variantJsonEl = form.querySelector('[data-variant-json]');
  const typeFieldset = root.querySelector('fieldset.variant-input-wrap--reusable-bags-type');
  const sizeFieldset = root.querySelector('fieldset.variant-input-wrap--reusable-bags-pills');
  if (!variantJsonEl || !typeFieldset || !sizeFieldset) return;

  let variants;
  try {
    variants = JSON.parse(variantJsonEl.textContent || variantJsonEl.innerHTML || '[]');
  } catch (_) {
    return;
  }
  if (!Array.isArray(variants) || variants.length === 0) return;

  const typeIdx = typeFieldset.dataset.index;
  const sizeIdx = sizeFieldset.dataset.index;
  if (!typeIdx || !sizeIdx) return;

  const updateSizeVisibility = () => {
    const typeChecked = typeFieldset.querySelector('input[type="radio"]:checked');
    const typeVal = typeChecked ? typeChecked.value : null;
    if (!typeVal) return;

    const wraps = sizeFieldset.querySelectorAll('.variant-input');
    let firstVisibleInput = null;

    wraps.forEach((wrap) => {
      const input = wrap.querySelector('input[type="radio"][data-variant-input]');
      if (!input) return;
      const sizeVal = input.value;
      const comboExists = variants.some((v) => v[typeIdx] === typeVal && v[sizeIdx] === sizeVal);
      if (comboExists) {
        wrap.classList.remove('reusable-bags-variant-input--hidden-for-type');
        if (!firstVisibleInput) firstVisibleInput = input;
      } else {
        wrap.classList.add('reusable-bags-variant-input--hidden-for-type');
        if (input.checked) input.checked = false;
      }
    });

    const stillChecked = sizeFieldset.querySelector('input[type="radio"]:checked');
    const stillWrap = stillChecked && stillChecked.closest('.variant-input');
    const checkedIsHidden =
      stillWrap && stillWrap.classList.contains('reusable-bags-variant-input--hidden-for-type');

    if ((!stillChecked || checkedIsHidden) && firstVisibleInput) {
      sizeFieldset.querySelectorAll('input[type="radio"]').forEach((inp) => {
        if (inp !== firstVisibleInput) inp.checked = false;
      });
      firstVisibleInput.checked = true;
      firstVisibleInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  typeFieldset.querySelectorAll('input[type="radio"][data-variant-input]').forEach((input) => {
    input.addEventListener('change', () => queueMicrotask(updateSizeVisibility));
  });

  root.addEventListener('variantChange', () => queueMicrotask(updateSizeVisibility));

  queueMicrotask(updateSizeVisibility);
}

/* PALM-003-DI — Ultimate Trust Badges (and similar) inject inside the ATC form; move host under qty+ATC row */
function findReusableBagsTrustHostInForm(form) {
  var byId = form.querySelector('#ultimateTrustBadgeswidgetDiv');
  if (byId) {
    return byId;
  }
  var byIdPartial = form.querySelector('[id*="ultimateTrust"][id*="widget"]');
  if (byIdPartial) {
    return byIdPartial;
  }
  var iframe = form.querySelector('iframe#trust-bar[title="trust-badges-widget"]');
  if (!iframe) {
    return null;
  }
  var parent = iframe.parentElement;
  if (parent && parent !== form) {
    return parent;
  }
  return iframe;
}

/* PALM-003-DI */
function syncReusableBagsChecklistFirstLine(root) {
  const target = root.querySelector('[data-reusable-bags-checklist-first-text]');
  const typeFieldset = root.querySelector('fieldset.variant-input-wrap--reusable-bags-type');
  if (!target || !typeFieldset) return;

  const isNonFlatBottomType = (value) => {
    const normalized = (value || '').toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
    return normalized.includes('non flat bottom');
  };

  const getSourceKey = () => {
    const checked = typeFieldset.querySelector('input[type="radio"]:checked');
    if (!checked) return 'flat';
    return isNonFlatBottomType(checked.value) ? 'non-flat' : 'flat';
  };

  const update = () => {
    const key = getSourceKey();
    const source = root.querySelector(`[data-reusable-bags-checklist-source="${key}"]`);
    if (!source) return;
    target.innerHTML = source.innerHTML;
  };

  typeFieldset.querySelectorAll('input[type="radio"][data-variant-input]').forEach((input) => {
    input.addEventListener('change', () => queueMicrotask(update));
  });
  root.addEventListener('variantChange', () => queueMicrotask(update));
  queueMicrotask(update);
}

function initReusableBagsTrustRelocate(root) {
  var slot = root.querySelector('[data-reusable-bags-trust-slot]');
  var form = root.querySelector('.product-single__form--reusable-bags');
  if (!slot || !form) {
    return;
  }

  function relocate() {
    var host = findReusableBagsTrustHostInForm(form);
    if (!host || slot.contains(host)) {
      return;
    }
    slot.appendChild(host);
  }

  relocate();

  var observer = new MutationObserver(function () {
    relocate();
  });
  observer.observe(form, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.product-section--reusable-bags');
  if (!root) return;

  queueMicrotask(() => initReusableBagsTrustRelocate(root));
  queueMicrotask(() => initReusableBagsSizeByType(root));
  queueMicrotask(() => syncReusableBagsChecklistFirstLine(root));

  const scheduleTypeAvailability = () =>
    queueMicrotask(() => syncReusableBagsTypePickerAvailability(root));
  root.addEventListener('variantChange', scheduleTypeAvailability);
  scheduleTypeAvailability();
  setTimeout(scheduleTypeAvailability, 0);

  const target = root.querySelector('[data-reusable-bags-atc-price]');
  if (target) {
    const applyAtcPrice = () => {
      const cents = getReusableBagsSelectedVariantCents(root);
      if (cents == null) return;
      const html = formatReusableBagsAtcPriceFromCents(cents);
      if (html) {
        target.innerHTML = html;
        target.className = 'reusable-bags-atc__price';
      }
    };
    applyAtcPrice();
    root.addEventListener('variantChange', () => queueMicrotask(applyAtcPrice));
  }
});
